// frontend/src/config/api.js
// Centralized API configuration for all services

export const API_BASE_URL = 
  process.env.REACT_APP_API_BASE ||
  (process.env.NODE_ENV === 'production'
    ? 'https://5gp7mnnjwf.execute-api.us-west-2.amazonaws.com/prod'
    : 'http://localhost:3000/api');

export default API_BASE_URL;
